export default "__VITE_ASSET__5c168a99__"